const produtoFluxo = (DataBase, Datatype) => {
	const ProdutoFluxo = DataBase.new(
		{
			id_cliente: Datatype.STRING,
			id_pedido: Datatype.STRING,
			c_nfe: Datatype.STRING,
			quantidade: Datatype.NUMBER,
			valor_un: Datatype.NUMBER,
			entrada: Datatype.BOOLEAN,
			motivo: Datatype.STRING,
		},
		{
			tracked: true,
			dateLogs: true,
			softDelete: true,
			collection: "produto_fluxo",
			model: "ProdutoFluxo",
			parent: "Produto",
		}
	);

	ProdutoFluxo.defaults = {
		valor_un: 0,
	};

	return ProdutoFluxo;
};

export default produtoFluxo;
